export default __webpack_public_path__ + "static/media/publish.990eb1fc.png";